import posthog from "posthog-js"

import { isPostHogEnabled } from "@/lib/posthog-enabled"
import { shouldDropPostHogExceptionEvent } from "@/lib/posthog-exception-filter"

type PosthogInitState = "never" | "ok" | "failed"

let posthogClientInitState: PosthogInitState = "never"

/**
 * Inicializa o PostHog no browser no máximo uma vez por carregamento da página.
 * Usado por `instrumentation-client.ts` (retorno com cookie aceito) e por
 * `CookieConsentManager` após aceite — sem guard compartilhado o segundo
 * `posthog.init()` pode corromper estado ou falhar de forma intermitente.
 */
export function initPosthogClientOnce(): void {
  if (typeof window === "undefined" || posthogClientInitState !== "never") return
  if (!isPostHogEnabled()) {
    posthogClientInitState = "failed"
    return
  }
  const token = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN?.trim()
  if (!token) {
    posthogClientInitState = "failed"
    return
  }

  try {
    posthog.init(token, {
      api_host: "/ingest",
      ui_host: "https://us.posthog.com",
      defaults: "2026-01-30",
      capture_exceptions: true,
      debug: process.env.NODE_ENV === "development",
      before_send: (event) => {
        if (
          event &&
          event.event === "$exception" &&
          shouldDropPostHogExceptionEvent(event.properties ?? {})
        ) {
          return null
        }
        return event
      },
    })
    posthogClientInitState = "ok"
  } catch (error) {
    posthogClientInitState = "failed"
    console.warn("[PostHog] init falhou (análise desativada nesta sessão):", error)
  }
}
